export default __webpack_public_path__ + "static/media/tangueria-milonga.8573246c.svg";